const getDiscountedPrice = (price, discounts) => {
  const discountedPrice = discounts.reduce((acc, discount) => {
    const { shouldApplyToStickerPrice, amount } = discount;
    const amountWithDiscount = acc - amount;
    return shouldApplyToStickerPrice ? amountWithDiscount : acc;
  }, price);

  return discountedPrice;
};

export default getDiscountedPrice;
